import { coreService } from 'Src/network/AutomatedService';

const service = {
  getBranding: coreService['POS:GET:Location.Branding'],
};

export default service;
